import React from "react"
import MetaTags from "react-meta-tags"
import { Container } from "reactstrap"
import PackingTable from "../../components/Categories/All-Packing"

const AllPacking = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>All Packings | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <PackingTable />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AllPacking
